import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const getTags = () =>
  swRequest({
    path: "/api/tags/get_all",
  });

export const associateTags = (body) =>
  swRequest({
    path: "/api/tags/associate",
    method: "POST",
    body,
  });

export const modifyTags = (body) =>
  swRequest({
    path: "/api/tags/modify",
    method: "POST",
    body,
  });
